import { render } from "./CarSlider.vue?vue&type=template&id=5df57f6e&scoped=true"
import script from "./CarSlider.vue?vue&type=script&lang=js"
export * from "./CarSlider.vue?vue&type=script&lang=js"

import "./CarSlider.vue?vue&type=style&index=0&id=5df57f6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df57f6e"]])

export default __exports__